// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__oamKZ","footer":"ChangeClinic_footer__-ne2g"};